import(/* webpackMode: "eager", webpackExports: ["AmplifyConfig"] */ "/usr/src/app/front/apps/web/app/amplify-config.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/usr/src/app/front/apps/web/app/datadog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProviderWrapper"] */ "/usr/src/app/front/apps/web/app/posthog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/usr/src/app/front/apps/web/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/front/apps/web/app/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["BrowserCheck"] */ "/usr/src/app/front/apps/web/components/browser-check.tsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/front/shared/editor/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/front/packages/consult-table/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
